import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfSwiperOnlyH5 from '@elem/ui/ef-swiper-only-h5';
import EfTitle from '@elem/ui/ef-title';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.PowerAnytime');

    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732872910743/pc-tuya.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1732872910555/M-tuya.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732344860350/PowerAnytime-2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1732344841100/PowerAnytime-h5-2.jpg',
        },
    ];
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfTitle>{t('title')}</EfTitle>
            <div className="title-border-space"></div>
            <EfSection hasAnimation={false} label={t('label')} title={t('subTitle')} desc={t('desc')} />
            <EfSwiperOnlyH5 items={items} loop={true} />
            <EfSpec />
        </div>
    );
}
